<template>
  <div class="main-page">
    <mobile-header-bar></mobile-header-bar>
    <router-view></router-view>
    <mobile-footer></mobile-footer>
  </div>
</template>
<script>
import mobileHeaderBar from "@components/mobile/mobileHeaderBar";
import mobileFooter from "@components/mobile/mobileFooter";

export default {
  name: "",
  components: {
    mobileHeaderBar,
    mobileFooter,
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {},
  watch: {},
};
</script>
<style lang="less" scoped>
.main-page {
  width: 100%;
  height: 100%;
}
</style>
